import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { useWarehouseAccess } from '../hooks/useWarehouseAccess';

interface WarehouseManageGuardProps {
  children: ReactNode;
}

/**
 * Owner/admin-only Magazyn pages (e.g. Dostawcy). Gated on the selected
 * organization role; `RolesGuard` only knows the roles a user has anywhere.
 */
export default function WarehouseManageGuard({
  children,
}: WarehouseManageGuardProps): JSX.Element {
  const { canManage } = useWarehouseAccess();
  return canManage ? (
    <>{children}</>
  ) : (
    <Navigate to={PATH_DASHBOARD.warehouse.products} replace />
  );
}
